module.exports = __webpack_public_path__ + "static/media/img-msging.01bab77f.png";